import React from 'react';
import { IconProps } from '../types';

export const HRIcon = ({ color }: IconProps) => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_8892_8402)">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M13 4.66667C13 2.64162 14.6416 1 16.6667 1C18.6917 1 20.3333 2.64162 20.3333 4.66667C20.3333 6.69171 18.6917 8.33333 16.6667 8.33333C14.6416 8.33333 13 6.69171 13 4.66667ZM16.6667 3C15.7462 3 15 3.74619 15 4.66667C15 5.58714 15.7462 6.33333 16.6667 6.33333C17.5871 6.33333 18.3333 5.58714 18.3333 4.66667C18.3333 3.74619 17.5871 3 16.6667 3Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.33333 14.3333C5.30829 14.3333 3.66667 15.975 3.66667 18C3.66667 20.025 5.30829 21.6667 7.33333 21.6667C9.35838 21.6667 11 20.025 11 18C11 15.975 9.35838 14.3333 7.33333 14.3333ZM5.66667 18C5.66667 17.0795 6.41286 16.3333 7.33333 16.3333C8.25381 16.3333 9 17.0795 9 18C9 18.9205 8.25381 19.6667 7.33333 19.6667C6.41286 19.6667 5.66667 18.9205 5.66667 18Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7.33333 23.6667C3.83571 23.6667 1 26.5024 1 30C1 30.5523 1.44772 31 2 31H12.6667C13.219 31 13.6667 30.5523 13.6667 30C13.6667 26.5024 10.831 23.6667 7.33333 23.6667ZM7.33333 25.6667C9.38221 25.6667 11.0992 27.089 11.5507 29H3.11598C3.56748 27.089 5.28446 25.6667 7.33333 25.6667Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22.3333 18C22.3333 15.975 23.975 14.3333 26 14.3333C28.025 14.3333 29.6667 15.975 29.6667 18C29.6667 20.025 28.025 21.6667 26 21.6667C23.975 21.6667 22.3333 20.025 22.3333 18ZM26 16.3333C25.0795 16.3333 24.3333 17.0795 24.3333 18C24.3333 18.9205 25.0795 19.6667 26 19.6667C26.9205 19.6667 27.6667 18.9205 27.6667 18C27.6667 17.0795 26.9205 16.3333 26 16.3333Z"
                fill={color}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M26 23.6667C22.5024 23.6667 19.6667 26.5024 19.6667 30C19.6667 30.5523 20.1144 31 20.6667 31H31.3333C31.8856 31 32.3333 30.5523 32.3333 30C32.3333 26.5024 29.4976 23.6667 26 23.6667ZM26 25.6667C28.0489 25.6667 29.7659 27.089 30.2174 29H21.7826C22.2341 27.089 23.9511 25.6667 26 25.6667Z"
                fill={color}
            />
            <path
                d="M16.6667 10.3333C14.7744 10.3333 13.076 11.1644 11.9171 12.4767C11.5515 12.8907 11.5908 13.5226 12.0047 13.8882C12.4187 14.2538 13.0506 14.2146 13.4162 13.8006C14.212 12.8996 15.3723 12.3333 16.6667 12.3333C17.9615 12.3333 19.1215 12.8986 19.9167 13.8002C20.2821 14.2144 20.914 14.2539 21.3282 13.8886C21.7424 13.5233 21.782 12.8913 21.4166 12.4772C20.2572 11.1627 18.5585 10.3333 16.6667 10.3333Z"
                fill={color}
            />
        </g>
        <defs>
            <clipPath id="clip0_8892_8402">
                <rect width="32" height="32" fill={color} />
            </clipPath>
        </defs>
    </svg>
);
